import {AfterViewInit, Component, Host, Input} from '@angular/core';
import {Destroyable} from '../../../../destroyable.component';

import {ChipsComponent, TagValue} from '../chips.component';

@Component({
  selector: 'gp-chips-option',
  templateUrl: './chips-option.component.html',
  styleUrls: ['./chips-option.component.scss'],
  providers: [ChipsComponent]
})
export class ChipsOptionComponent extends Destroyable implements AfterViewInit {
  @Input('ngValue')
  public value: TagValue;

  constructor(@Host() private host: ChipsComponent) {
    super();
  }

  ngAfterViewInit() {
    this.host.setOption(this.value);
  }

  public select() {
    this.host.addValue(this.value);
  }

  public getDisplayValue(value: TagValue) {
    return this.host.getDisplayValue(value);
  }
}
